export enum FieldType {
    Text = 0,
    Hidden = 1,
    Boolean = 2,
}
